import client from "./client";

export const getBasic = () => client.post("/basic/getInfo");
export const addBasic = (payload) => client.post("/basic/addInfo", payload);
export const updateBasic = (payload) =>
  client.post("/basic/updateInfo", payload);
export const deleteBasic = () => client.post("/basic/deleteInfo");
